// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IInvestmentStatusResponse,
} from '../models/index';
import {
    IInvestmentStatusResponseFromJSON,
    IInvestmentStatusResponseToJSON,
} from '../models/index';

export interface GetInvestorStatusRequest {
    employeeId?: number;
}

/**
 * InvestmentControllerApi - interface
 * 
 * @export
 * @interface InvestmentControllerApiInterface
 */
export interface InvestmentControllerApiInterface {
    /**
     * 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentControllerApiInterface
     */
    getInvestorStatusRaw(requestParameters: GetInvestorStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestmentStatusResponse>>;

    /**
     */
    getInvestorStatus(requestParameters: GetInvestorStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestmentStatusResponse>;

}

/**
 * 
 */
export class InvestmentControllerApi extends runtime.BaseAPI implements InvestmentControllerApiInterface {

    /**
     */
    async getInvestorStatusRaw(requestParameters: GetInvestorStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestmentStatusResponse>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/investment-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestmentStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInvestorStatus(requestParameters: GetInvestorStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestmentStatusResponse> {
        const response = await this.getInvestorStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
